import { useFilters } from 'modules/shift_management/hooks/useFilters'

// TODO: remove this hook and use the filters hook instead
const useLocationIdsFilter = (): number[] => {
  const [filters] = useFilters()
  return filters.locationIds
}

export default useLocationIdsFilter
